import {GET_STUDENTS, GET_STUDENTS_FAILED, GET_STUDENTS_SUCCESS} from '../actions/students';
import {errorMessageFromPayload} from "../utils/errors";
import {SYNC_RESET_DEVICE_SUCCESS} from "../actions/sync";

const defaultState = {
  list: [],
  loading: false,
  error: ''
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case GET_STUDENTS: {
      return {...state, loading: true};
    }
    case GET_STUDENTS_SUCCESS: {
      return {...state, loading: false, list: action.payload};
    }
    case GET_STUDENTS_FAILED: {
      return {...state, loading: false, error: errorMessageFromPayload(action.payload)};
    }
    case SYNC_RESET_DEVICE_SUCCESS: {
      return defaultState;
    }
    default:
      return state;
  }
}
